// @flow

import { Hide, Interactive, Svg, Text } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectWebURL } from 'src/modules/config';

import { Hamburger } from '../Hamburger';

import { SplitNavigation } from '../SplitNavigation';

import styles from './LandingPagesControls.scss';

type Props = {
  hamburgerClassName: string,
  toggleOpen: (() => void) | { open: boolean, toggleOpen: () => mixed },
};

export function LandingPagesControls({
  hamburgerClassName,
  toggleOpen,
}: Props): React.MixedElement {
  const webURL = useAppSelector(selectWebURL);

  return (
    <>
      <Hide from="sm">
        <Hamburger onClick={toggleOpen} className={hamburgerClassName} />
      </Hide>
      <Interactive
        href={webURL}
        flex
        flexJustifyCenter
        flexAlignItemsCenter
        className={styles.logoContainer}
      >
        <Hide at="xsm" from="md">
          <Svg
            name="gandiIcon"
            theme="neutral-strong"
            title="\o/ Gandi.net"
            className={styles.logo}
          />
        </Hide>
        <Hide until="md">
          <Svg
            name="gandi"
            theme="neutral-strong"
            title="\o/ Gandi.net"
            className={styles.logo}
          />
        </Hide>
        <Hide from="sm">
          <Text aria-hidden tagName="span">
            Gandi.net
          </Text>
        </Hide>
      </Interactive>
      <Hide until="sm">
        <SplitNavigation />
      </Hide>
    </>
  );
}
